import { ENSURE_SLIM_DEVICES_LOADED } from '../actionTypes';
import fetchSlimDevices from './fetchSlimDevices';

const MAX_CHUNK = 1000 as const;
const MAX_REQUESTS = 5 as const;

async function* resultGenerator(
  requestChunks: Array<Array<Array<HologramSimId>>>,
  dispatch: any,
  orgId?: OrgId
) {
  let i = 0;

  while (i < requestChunks.length) {
    const requests = requestChunks[i].map(async (chunk) => {
      await dispatch(fetchSlimDevices(chunk, orgId));
    });

    yield Promise.all(requests);
    i += 1;
  }
}

const ensureDevicesPersisted =
  (deviceIds: Array<DeviceId>, orgId?: OrgId) => async (dispatch, getState) => {
    dispatch({ type: ENSURE_SLIM_DEVICES_LOADED });

    const { devices } = getState();

    const cachedKeys = new Set(Object.keys(devices.devicesCache).map((key) => parseInt(key, 10)));
    const uncachedIds = new Set(deviceIds.filter((deviceId) => !cachedKeys.has(deviceId)));

    const isDevEnv = process.env.NODE_ENV === 'development';

    if (isDevEnv) {
      // eslint-disable-next-line no-console
      console.log('ensureDevicesPersisted', {
        deviceIds,
        uncachedIds,
      });
    }

    // and then save them
    if (uncachedIds.size > 0) {
      const chunks = [...uncachedIds.values()].reduce<Array<Array<DeviceId>>>(
        (resultArray, item, index) => {
          const chunkIndex = Math.floor(index / MAX_CHUNK);

          if (!resultArray[chunkIndex]) {
            // eslint-disable-next-line no-param-reassign
            resultArray[chunkIndex] = [];
          }

          resultArray[chunkIndex].push(item);

          return resultArray;
        },
        []
      );

      const requestChunks = chunks.reduce<Array<Array<Array<DeviceId>>>>(
        (resultArray, item, index) => {
          const chunkIndex = Math.floor(index / MAX_REQUESTS);

          if (!resultArray[chunkIndex]) {
            // eslint-disable-next-line no-param-reassign
            resultArray[chunkIndex] = [];
          }

          resultArray[chunkIndex].push(item);

          return resultArray;
        },
        []
      );

      // eslint-disable-next-line no-restricted-syntax, @typescript-eslint/no-unused-vars
      for await (const resultChunk of resultGenerator(requestChunks, dispatch, orgId)) {
        // Empty
      }
    }
  };

export default ensureDevicesPersisted;
